import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgShieldIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6.543 16.84a.74.74 0 0 0 .914 0C8.858 15.75 13 12.188 13 8.126V3.744a.47.47 0 0 0-.111-.307.44.44 0 0 0-.28-.15 10.1 10.1 0 0 1-4.785-1.82l-.523-.37a.52.52 0 0 0-.602 0l-.523.37a10.1 10.1 0 0 1-4.784 1.82.44.44 0 0 0-.281.15.47.47 0 0 0-.111.307v4.382c0 4.062 4.142 7.624 5.543 8.712" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 18" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default SvgShieldIcon;